import React from 'react';
import { services } from '../data/mock';

const ServicesSection = ({ compact = false }) => {
  return (
    <section id="services" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <div className="text-center mb-20">
          <p className="text-neutral-500 text-xs uppercase tracking-[0.35em] mb-4">What I offer</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-neutral-900 font-bold tracking-tight">
            Discipline Services
          </h2>
          <div className="mt-6 mx-auto w-16 h-px bg-neutral-900" />
        </div>

        <div className="space-y-24 md:space-y-32">
          {services.map((service, idx) => (
            <div
              key={service.id}
              className={`grid md:grid-cols-2 gap-10 lg:gap-16 items-center ${
                idx % 2 === 1 ? 'md:[&>*:first-child]:order-2' : ''
              }`}
            >
              <div className="overflow-hidden group">
                <img
                  src={service.image}
                  alt={service.imageAlt}
                  className="w-full h-[420px] md:h-[520px] object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div>
                <p className="text-neutral-500 text-xs uppercase tracking-[0.3em] mb-3">
                  0{idx + 1} / 0{services.length}
                </p>
                <h3 className="font-serif text-3xl md:text-4xl text-neutral-900 font-bold mb-4">
                  {service.title}
                </h3>
                <p className="text-neutral-700 italic mb-6 text-lg">{service.subtitle}</p>
                <div className="space-y-4 text-neutral-700 leading-relaxed">
                  {service.paragraphs.map((p) => (
                    <p key={p.slice(0, 40)}>{p}</p>
                  ))}
                </div>
                {service.bullets && (
                  <div className="mt-6">
                    {service.bulletsTitle && (
                      <p className="font-semibold text-neutral-900 mb-3">{service.bulletsTitle}</p>
                    )}
                    <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
                      {service.bullets.map((b) => (
                        <li key={b} className="text-neutral-700 text-sm flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-neutral-900 rounded-full" />
                          {b}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
